import { IParamsGetActivityEngagement } from 'app/api/activityEngagement/model'

export const ActivityEngagementKeys = {
  allActivityEngagements: ['ActivityEngagements'] as const,
  listActivityEngagements: () =>
    [
      ...ActivityEngagementKeys.allActivityEngagements,
      'listActivityEngagements',
    ] as const,
  listActivityEngagement: (filter?: IParamsGetActivityEngagement) =>
    [...ActivityEngagementKeys.listActivityEngagements(), { filter }] as const,
}
